<template>
    <div>
        <PXCreateSurveyAutomaticPage v-if="mode == 'IWAK' || mode == 'STRESS'" :mode="mode"/>
        <PXCreateSurveyManualPage v-if="mode == 'MANUAL'"/>
    </div>
</template>

<script>
import pxQuestionService from '@/pages/PxQuestionSurvey/PXQuestionsPage/px-question-service'
import FormDialog from '@/components/common/FormDialog.vue';
import PXCreateSurveyAutomaticPage from './PXCreateSurveyIWAKPage.vue';
import PXCreateSurveyManualPage from './PXCreateSurveyManualPage.vue';
export default {
  components: {
    FormDialog,
    PXCreateSurveyAutomaticPage,
    PXCreateSurveyManualPage
  },
  data: () => ({
    pxQuestions: {},
    mode: ""
  }),
  watch: {
  },
  mounted() {
    this.mode = this.$route.params.mode;
    //this.fetchPxQuestions();
  },
  methods: {
      updateSelectedQuestions(checkboxValue, question){
          if(this.selectedQuestions.includes(question) && !checkboxValue){
              let indexOfSelected = this.selectedQuestions.indexOf(question);
              this.selectedQuestions.splice(indexOfSelected, 1);
          }else{
              this.selectedQuestions.push(question);
          }
      },
      fetchPxQuestions(){
          pxQuestionService.retrievePXQuestions().then((result) => {
              let userQuestions = result.data.filter(elem => elem.type == 'USER');
              let roleQuestions = result.data.filter(elem => elem.type == 'ROLE');
              let activityQuestions = result.data.filter(elem => elem.type == 'ACTIVITY');
              let processQuestions = result.data.filter(elem => elem.type == 'PROCESS');

              this.pxQuestions = {
                  userQuestions,
                  roleQuestions,
                  activityQuestions,
                  processQuestions
              }
          })
      },
      generateSurvey(){
        this.$refs.formDialog
            .open(
            "Bitte geben Sie der Umfrage einen Namen:"
            )
            .then((surveyTitle) => {
                this.$router.push({
                name: 'generatedSurvey',
                params: {
                    questions: this.selectedQuestions,
                    surveyTitle: surveyTitle
                }
                })
        });
      }
  },
};
</script>
<style scoped>
.frame{
    border: 1px solid lightgray;
    margin:5px;
}
.row{
    margin:5px;
}
.filter{
    width:10%;
    float:right;
    margin-right: 10px;
}
.table-header{
    padding:0 !important
}
.bottomButton{
    width: calc(100% - 20px);
    margin:10px;
}
</style>